import { SITE_URL } from "@/lib/seo";
import { SOCIAL_PROFILES } from "@/lib/social-profiles";

export const SUPPORT_EMAIL = "support@briefpanel.com";

/**
 * schema.org `Organization` for the company behind the site. Rendered in the
 * locale layout's `<head>` so every page carries it, not only the homepage;
 * some AI-visibility auditors only read `<head>`.
 */
export const ORGANIZATION_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "BriefPanel",
  legalName: "To Play Along LTDA",
  url: SITE_URL,
  logo: `${SITE_URL}/logo-name-600w.jpg`,
  email: SUPPORT_EMAIL,
  sameAs: SOCIAL_PROFILES.map((profile) => profile.url),
};
